import { Box, Button, TextField } from '@mui/material'
import { Formik } from 'formik'
import useMediaQuery from '@mui/material/useMediaQuery'
import Header from '../../components/Header'
import React from "react"
import { useState } from "react"
import { useNavigate } from 'react-router-dom'
import * as Constants from '../../constants'
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material'

const AddUser = () => {
  const isNonMobile = useMediaQuery('(min-width:600px)')

  let navigate = useNavigate()
  const handleBack = () => {
    navigate('/team')
  }

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })

  const [isAdmin, setIsAdmin] = useState(false)
  const [isOperator, setIsOperator] = useState(false)
  const [isLivestreamer, setIsLivestreamer] = useState(false)

  const handleCheckboxes = (e) => {
    if (e.target.name == 'admin') {
      if (e.target.checked) {
        setIsAdmin(true)
        setIsLivestreamer(false)
        setIsOperator(false)
      } else {
        setIsAdmin(false)
      }
    } else if (e.target.name == 'operator') {
      setIsOperator(e.target.checked)
    } else if (e.target.name == 'livestreams') {
      setIsLivestreamer(e.target.checked)
    }
  }

  const handleFormSubmit = (values) => {
    if (values.password !== values.confirmpass) {
      alert('As senhas não conferem')
    } else {
      fetch(Constants.HOST + '/createUser', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          token: JSON.parse(localStorage.getItem('user_data')).token,
          username: values.username,
          password: values.password,
          isAdmin: isAdmin,
          isOperator: isOperator,
          isLivestreamer: isLivestreamer
        }),
      })
        .then((response) => {
          if (response.status !== 400 && response.status !== 200) {
            setError({
              error: true,
              message: 'Erro de comunicação com o servidor',
            })
            setSuccess({ success: false, message: '' })
          } else {
            response.json().then((data) => {
              if (data.success) {
                setError({ error: false, message: '' })
                setSuccess({
                  success: true,
                  message: 'Usuário criado com sucesso',
                })
                values.username = ''
                values.password = ''
                values.confirmpass = ''
                setIsAdmin(false)
              } else {
                setSuccess({ success: false, message: '' })
                setError({ error: true, message: data.message })
              }
            })
          }
        })
        .catch(() => {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        })
    }
  }

  return (
    <Box m="20px">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Header
          title="Criar usuário"
          style={{ width: '100%', gridColumn: 'span 2' }}
        />
        {/* Go back button (X) */}
        <Button
          variant="contained"
          onClick={handleBack}
          sx={{ marginLeft: 'auto', gridColumn: 'span 1', height: '100%' }}
        >
          X
        </Button>
      </Box>

      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
        {({ values, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nome de usuário"
                onBlur={handleBlur}
                name="username"
                value={values.username}
                onChange={handleChange}
                sx={{ gridColumn: 'span 4' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Senha"
                onBlur={handleBlur}
                name="password"
                value={values.password}
                onChange={handleChange}
                sx={{ gridColumn: 'span 2' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Confirme a nova senha"
                onBlur={handleBlur}
                onChange={handleChange}
                name="confirmpass"
                value={values.confirmpass}
                error={
                  touched.confirmpass && values.confirmpass !== values.password
                }
                sx={{ gridColumn: 'span 2' }}
                autoComplete="off"
              />
            </Box>

            <FormGroup
              onChange={handleCheckboxes}
              sx={{
                gridColumn: 'span 4',
                marginTop: '25px',
                fontColor: 'white',
              }}
            >
              <FormControlLabel
                name="admin"
                control={
                  <Checkbox checked={isAdmin} style={{ color: '#00e676' }} />
                }
                label="Administrador"
              />
              <FormControlLabel
                name="operator"
                control={
                  <Checkbox
                    checked={isOperator}
                    disabled={isAdmin}
                    style={{ color: '#00e676' }}
                  />
                }
                label="Operador de dispositivos"
              />
              <FormControlLabel
                name="livestreams"
                control={
                  <Checkbox
                    checked={isLivestreamer}
                    disabled={isAdmin}
                    style={{ color: '#00e676' }}
                  />
                }
                label="Operador de notificacoes"
              />
            </FormGroup>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Enviar
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  )
}

const initialValues = {
  username: '',
  password: '',
  confirmpass: '',
  is_admin: false,
}

export default AddUser
